import React, { FC } from 'react'
import styled from 'styled-components'
import { Field as FinalField } from 'react-final-form'
import { useFocus } from '@chilipiper/utils'
import { ThemeFontSizes } from '../../new/theme/types'
import { Field } from './Field'
import { FieldProps as FieldProps } from './types'

type InputType = Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'>

type TextareaElementProps = {
  'data-test-id'?: string
  fontSize?: ThemeFontSizes
  resize?: 'none' | 'vertical' | 'horizontal' | 'auto'
  rows?: number
} & InputType

/** @deprecated - See {@link TextArea} */
export type TextAreaProps = FieldProps & TextareaElementProps

const Input = styled.textarea<TextareaElementProps>`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-weight: inherit;
  background: none;
  padding: 0;
  color: ${props => props.theme.colors['text/form-value']};
  font-size: ${({ theme, fontSize }) => theme.fontSizes[fontSize || 14]};
  font-family: ${props => props.theme.fonts['primary']};
  resize: ${props => props.resize || 'auto'};
  line-height: 1.5;
`

/** @deprecated Use the new TextArea from `@chilipiper/design-system/src/new` instead */
export const TextArea: FC<TextAreaProps> = ({
  focused: focus,
  onFocus,
  onBlur,
  value,
  defaultValue,
  onChange,
  placeholder,
  id,
  name,
  resize = 'none',
  'aria-label': ariaLabel,
  'data-test-id': testId,
  ...p
}: TextAreaProps) => {
  const [focused, handleFocus, handleBlur] = useFocus(focus, onFocus, onBlur)
  return (
    <Field
      {...p}
      placeholder={placeholder}
      textArea
      focused={focused}
      value={value}
      roundedBottomCorners
    >
      <Input
        h={15}
        {...p}
        data-test-id={testId}
        aria-label={ariaLabel}
        resize={resize}
        value={value}
        defaultValue={defaultValue}
        id={id}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </Field>
  )
}

type FinalTextAreaProps = Omit<TextAreaProps, 'name'> & { name: string }

/** @deprecated Use the new TextArea from `@chilipiper/design-system/src/new` instead */
export const FinalTextArea: FC<FinalTextAreaProps> = ({ name, ...props }: FinalTextAreaProps) => {
  return (
    <FinalField name={name} parse={v => v}>
      {({ input, meta }) => <TextArea {...props} {...input} error={meta.error} />}
    </FinalField>
  )
}
